import { useState } from "react";

const useTextarea = () => {
  const [value, updateValue] = useState("");

  const onChange = (e) => {
    updateValue(e.target.value);
  }
  return {
    value,
    onChange,
  }
}

export default useTextarea;
